import React from 'react'
import ProfilePic from '../assets/profilepic.JPG'
const About = () => {
  return (
    <div id = 'about' className = "w-full md:h-screen p-2 flex items-center py-16">
      <div className = "max-w-[1240px] m-auto md:grid grid-cols-3 gap-8">
          <div className = "col-span-2">
                <p className = "py-4 text-4xl tracking-widest text-[#5651e5]"> ABOUT</p>
                <p className = "py-2 text-gray-600 pr-4">Hi, I'm Ankur! I am a second year student pursuing  Bachelors in <span className = "text-[#5651e5]">Computer Science &  Engineering </span>  from Punjab Engineering College.</p>
                <p className = "pr-4">I am a <span className = "text-[#5651e5]">Competitive Programmer</span>.
                I am <span className = "text-[#5651e5]">Specialist</span> on Codeforces and <span className = "text-[#5651e5]">4 Star</span> on Codechef. I have secured Global Rank 31 and India Rank 4 in Codeforces Round 799. I have also secured various top 100 Global ranks in Codechef Contests.</p>
                <p className = "py-2">I also enjoy <span className = "text-[#5651e5]">designing websites.</span></p>
                <div className = "flex justify-items-start items-center pt-12 text-md">CODING IDS -
                    <ul className = "flex">
                      <a href="https://codeforces.com/profile/ankurgupta_2002" target = '_blank'>
                      <li className = "ml-10 text-md uppercase hover:border-b text-[#5651e5]">Codeforces</li>
                      </a>
                      <a href="https://atcoder.jp/users/Ankur_Gupta" target = '_blank'>
                      <li className = "ml-10 text-md uppercase hover:border-b text-[#5651e5]">AtCoder</li>
                      </a>
                      <a href="https://www.codechef.com/users/pec_star_123" target = '_blank'>
                      <li className = "ml-10 text-md uppercase hover:border-b text-[#5651e5]">CodeChef</li>
                      </a>
                    </ul>
                </div>
          </div>
          <div className = "w-full h-auto m-auto shadow-xl shadow-gray-400 rounded-xl flex items-center justify-center p-4 hover:scale-105 ease-in duration-300">
                <img className = "rounded-xl" src={ProfilePic} alt="" />
          </div>
      </div>
    </div>
  )
}

export default About
